<button class="chatbase-dialog-close-button blue-flat-button" mat-dialog-close>
    {{'close' | translate}}
</button>
<iframe *ngIf="!iframeErrorLoading"
    id="iframe"
    src="https://www.chatbase.co/chatbot-iframe/H7yHzhDAN-JJSaSx8v_BB"
    width="100%"
    style="height: 100%"
    frameborder="0"
    (load)="iframeSuccessLoading = true"
    (error)="onErrorIframe($event)">
</iframe>
<div *ngIf="iframeErrorLoading" class="iframe-error">
    <img src="../../../assets/img/somenthing_went_wrong.svg" />
    <h1>{{ "ops" | translate }}</h1>
    <p>{{ "assistant.error-loading" | translate }}</p>
</div>
